
import {toggleSlide, toggleDisplay} from './Util';

class TriggerSlideNextClass {

	constructor( triggerEl ) {

		this.triggerEl = triggerEl;
		this.targetEls = [];

		let nextEl = triggerEl.nextElementSibling;
		while ( nextEl ) {
			if ( nextEl.classList.contains( triggerEl.dataset.slideNextClassTarget ) ) {
				this.targetEls.push( nextEl );
			}
			// Go to next element.
			nextEl = nextEl.nextElementSibling
		}

		const initAction = 'open' === triggerEl.dataset.slideNextClassInit;
		this.triggerEl.addEventListener( 'click', () => this.toggle() );
		this.toggle( initAction, false );
	}

	toggle( show = null, withAnimation = true ) {

		// When no parameter is passed, we toggle the current state.
		if ( null === show ) {
			show = ! this.triggerEl.classList.contains( 'active' );
		}

		this.triggerEl.classList.toggle( 'active', show );
		this.targetEls.forEach( targetEl => {
			targetEl.classList.toggle( 'active', show );
			if ( withAnimation ) {
				toggleSlide( targetEl, !!show );
			} else {
				toggleDisplay( targetEl, !!show );
			}
		} );
	}
}

const initTriggerSlideNextClass = function( scopeEl = document ) {
	// Initialise SlideNextClass Trigger.
	const slideNextClassEls = Array.from( scopeEl.querySelectorAll( '[data-slide-next-class]' ) );
	slideNextClassEls.forEach( slideNextClassEl => {
		// Only init once per element - even if the function is called multiple times.
		slideNextClassEl.EN_TriggerSlideNextClass ??= new TriggerSlideNextClass( slideNextClassEl );
	} );
};

export {
	TriggerSlideNextClass as default,
	initTriggerSlideNextClass
}
